import {
    styled,
    Box,
    IconButton,
    Typography,
    Select,
    Paper,
    FormControl
} from '@mui/material';
import color from 'src/theme/color';

export const ServicesCard = styled(Box)({
    width: '40%',
    background: color.blackLight,
    borderRadius: '8px',
    padding: '30px 40px 60px 40px',
    position: 'relative',
    color: color.white,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
});

export const StyledDivider = styled('div')({
    marginTop: '14px',
    marginBottom: '14px',
    backgroundColor: color.grey2,
    height: '0.5px'
});

export const ButtonContentBox = styled(Box)({
    marginTop: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: '100%',
    margin: '0 auto'
});

export const TeamServicesCard = styled(ServicesCard)({
    width: '20%',
    backgroundColor: color.blackLight,
    color: color.grey
});

export const TeamTitleBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    backgroundColor: color.blackLight
});

export const TeamIconButton = styled(IconButton)({
    position: 'absolute',
    left: 0,
    color: color.grey
});

export const TeamTitleTypography = styled(Typography)({
    width: '100%',
    textAlign: 'center',
    color: color.grey
}) as typeof Typography;

export const TeamLabelTypography = styled(Typography)({
    textAlign: 'left',
    marginBottom: '10px',
    color: color.grey
});

export const TeamMemberNameTypography = styled(Typography)({
    textAlign: 'left',
    color: color.white,
    fontSize: '18px',
    marginBottom: 0
});

export const TeamMemberEmailTypography = styled(Typography)({
    textAlign: 'left',
    color: color.grey,
    marginTop: '4px'
});

export const StyledAutocomplete = styled(Box)({
    width: '100%',
    marginBottom: 2,
    '& .MuiOutlinedInput-root': {
        padding: '8px 12px',
        color: color.grey,
        backgroundColor: color.blackLight2
    },
    '& .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${color.grey}`,
        borderRadius: '4px'
    },
    '& .MuiInputLabel-root': {
        color: color.grey
    },
    '& .MuiAutocomplete-input': {
        padding: '0 !important',
        height: '24px',
        color: color.white
    },
    '& .MuiAutocomplete-endAdornment': {
        right: '8px'
    },
    '& .MuiInputAdornment-root': {
        marginRight: '8px',
        color: color.grey
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${color.yellow60} !important`,
        borderColor: `${color.yellow60} !important`
    }
});

export const StyledAutocompleteOption = styled('div')({
    color: color.white,
    fontSize: '14px'
});

export const StyledAutocompletePaper = styled(Paper)({
    backgroundColor: color.blackLight2,
    color: color.grey,
    '& .MuiAutocomplete-option': {
        padding: '8px 12px'
    }
});

export const StyledFormControl = styled(FormControl)({
    backgroundColor: color.blackLight,
    '&:hover': {
        backgroundColor: color.blackLight
    }
});

export const StyledSelect = styled(Select)({
    backgroundColor: color.blackLight2,
    color: color.grey,
    '& .MuiSelect-icon': {
        color: color.yellow
    },
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none'
    }
});

export const StyledSelectOption = styled(Box)({
    display: 'flex',
    alignItems: 'center'
});

export const StyledSelectText = styled(Box)({
    marginLeft: 8
});
